import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-progress-overlay__logo"
}
const _hoisted_2 = { class: "gfu-progress-overlay__message" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-progress-overlay', $options.classes]),
    "data-qa": "progress-overlay"
  }, [
    ($props.centerInView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.message), 1 /* TEXT */)
  ], 2 /* CLASS */))
}